export const SET_DICTLANGUAGE = 'SET_DICTLANGUAGE';
export const SET_DICTLANGUAGES = 'SET_DICTLANGUAGES';
export const SET_DICTLANGUAGES_QUERY_PARAMS = 'SET_DICTLANGUAGES_QUERY_PARAMS';
export const SET_DICTLANGUAGES_SET_IS_FETCHING = 'SET_DICTLANGUAGES_SET_IS_FETCHING';
